// Utilities for persisting host flag across sessions
const HOST_FLAG_KEY = 'dice1k_isHost';

export function loadHostFlag(): boolean {
  if (typeof window === 'undefined') return false;
  try { return localStorage.getItem(HOST_FLAG_KEY) === 'true'; } catch { return false; }
}

export function saveHostFlag(v: boolean) {
  if (typeof window === 'undefined') return;
  try { localStorage.setItem(HOST_FLAG_KEY, v ? 'true' : 'false'); } catch {}
}
